// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaticBlockForm-commonHeaderAdmin-ZAV_y {
	position: fixed !important;
}

.StaticBlockForm-adminLayout-IeAZ_ {
	padding-top: 64px !important;
}

.StaticBlockForm-box-OD2Ko h2 {
	font-size: 21px;
	font-weight: 600;
}

.StaticBlockForm-exportLink-IickN {
	margin-bottom: -29px;
}

.StaticBlockForm-blockCenter-oze8E {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.StaticBlockForm-panelHeader-O17J9 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.StaticBlockForm-currencyselect-r2Xoa {
	width: 100%;
	margin-right: 0px;
}

.StaticBlockForm-panelHeader-O17J9 {
	overflow: hidden;
	position: relative;
}

.StaticBlockForm-mar0-q7D32 {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.StaticBlockForm-blockCenter-oze8E {
		padding: 0px;
	}

	.StaticBlockForm-panelHeader-O17J9 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.StaticBlockForm-sideAdminPageWrapper-golZJ {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.StaticBlockForm-panelHeader-O17J9 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.StaticBlockForm-table-jbFYH {
	display: table;
}

.StaticBlockForm-tableRow-bxC4M {
	display: table-row;
}

.StaticBlockForm-tableCell-plkRP {
	display: table-cell;
	float: none;
}

.StaticBlockForm-formGroup-o0yik {
	margin-bottom: 6px;
}

.StaticBlockForm-select-ttYb9 {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.StaticBlockForm-noMargin-ZsJL5 {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.StaticBlockForm-exportLink-IickN {
	padding-top: 10px;
	padding-right: 10px;
}

.StaticBlockForm-labelTextNew-VIRQw {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.StaticBlockForm-displayInline-MK80N {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.StaticBlockForm-btnUPdate-csauw {
	display: inline-block;
}

.StaticBlockForm-btnModalDelete-hDjhx {
	display: inline-block;
	margin-left: 15px;
}

.StaticBlockForm-radioBtn-qjAkw {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.StaticBlockForm-backgroundImg-NtMxO {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.StaticBlockForm-btnUPdate-csauw {
		display: block;
		margin-bottom: 12px;
	}

	.StaticBlockForm-btnModalDelete-hDjhx {
		display: block;
		margin-left: 0px;
	}

	.StaticBlockForm-btnWidth-OL75q {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.StaticBlockForm-bannerImageBg-JQ1kK {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.StaticBlockForm-bannerDelete-lhvgN {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.StaticBlockForm-modalRoot-jlMgd {
	padding: 32px;
}

.StaticBlockForm-modalBorderBottom-A2vmu {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.StaticBlockForm-logInModalBody-G6wHW {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.StaticBlockForm-exportSection-lA8tJ {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.StaticBlockForm-exportSectionGridSub-ZcBf1 {
	grid-template-columns: 50% 49% !important;
}

.StaticBlockForm-exportText-Vpeae {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.StaticBlockForm-exportLinkImg-hjILQ {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.StaticBlockForm-vtrMiddle-yljbZ {
	vertical-align: middle;
}

.StaticBlockForm-exportImg-VfTXz {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.StaticBlockForm-profileViewlabel-gzThf {
	display: inline-block;
	width: 38%
}

.StaticBlockForm-profileViewMainContent-jfxOg {
	display: inline-block;
	width: 62%;
}

.StaticBlockForm-profileViewMain-hwGPQ {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.StaticBlockForm-profileViewInner-hYQAG {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.StaticBlockForm-profileImageSection-cUk_z {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.StaticBlockForm-lastviewInner-stMlf {
	padding: 10px;
}

.StaticBlockForm-whyHostHoriLine-escbg {
	margin: 30px 0;
}

.StaticBlockForm-tableGrid-U0lSv {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.StaticBlockForm-headingContent-x9dkr {
	font-size: 18px;
	font-weight: 500;
}

.StaticBlockForm-refundTextColor-DttG9 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.StaticBlockForm-dividerLine-Powkx {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.StaticBlockForm-smallContent-FkhOs {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.StaticBlockForm-sideAdminPageWrapper-golZJ {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.StaticBlockForm-sideAdminPageWrapper-golZJ {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.StaticBlockForm-exportSection-lA8tJ {
		grid-template-columns: 100%;
	}

	.StaticBlockForm-exportSectionGridSub-ZcBf1 {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.StaticBlockForm-profileViewlabel-gzThf {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.StaticBlockForm-profileViewMainContent-jfxOg {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.StaticBlockForm-ChangeToUpperCase-yYWws {
	text-transform: uppercase
}

.StaticBlockForm-noBorder-oRma7 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.StaticBlockForm-siteAdminHeading-KmGRc {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.StaticBlockForm-siteAdminSubHeading-yyOd_ {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.StaticBlockForm-adminFormDivider-l5nWV {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.StaticBlockForm-errorMessage-hsZfW {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.StaticBlockForm-panelHeader-O17J9 {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.StaticBlockForm-formGroup-o0yik {
  margin-bottom: 6px;
}

.StaticBlockForm-select-ttYb9 {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.StaticBlockForm-labelText-_zWzW {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.StaticBlockForm-space1-OTlM4 {
	margin-bottom: 6px !important;
}

.StaticBlockForm-space2-VFpvR {
	margin-bottom: 12px !important;
}

.StaticBlockForm-space3-SPgPQ {
	margin-bottom: 18px !important;
}

.StaticBlockForm-space4-PeyF_ {
	margin-bottom: 24px !important;
}

.StaticBlockForm-space5-QoSU7 {
	margin-bottom: 30px !important;
}

.StaticBlockForm-space6-KY2O9 {
	margin-bottom: 36px !important;
}

.StaticBlockForm-space7-p5ssf {
	margin-bottom: 42px !important;
}

.StaticBlockForm-spaceTop8-Cm4MQ {
	margin-bottom: 48px !important;
}

.StaticBlockForm-spaceTop1-eId2C {
	margin-top: 6px !important;
}

.StaticBlockForm-spaceTop2-OmgY8 {
	margin-top: 12px !important;
}

.StaticBlockForm-spaceTop3-nkHH7 {
	margin-top: 18px !important;
}

.StaticBlockForm-spaceTop4-GvtCw {
	margin-top: 24px !important;
}

.StaticBlockForm-spaceTop5-ZUdi3 {
	margin-top: 30px !important;
}

.StaticBlockForm-spaceTop6-re7EM {
	margin-top: 36px !important;
}

.StaticBlockForm-spaceTop7-F_por {
	margin-top: 42px !important;
}

.StaticBlockForm-spaceTop8-Cm4MQ {
	margin-top: 48px !important;
}

.StaticBlockForm-noMargin-ZsJL5 {
	margin: 0px !important;
}

.StaticBlockForm-padding1-Ql0lK {
	padding-bottom: 6px !important;
}

.StaticBlockForm-padding2-K_hTQ {
	padding-bottom: 12px !important;
}

.StaticBlockForm-padding3-HUZKd {
	padding-bottom: 18px !important;
}

.StaticBlockForm-padding4-zOhdx {
	padding-bottom: 24px !important;
}

.StaticBlockForm-padding5-sHjtO {
	padding-bottom: 30px !important;
}

.StaticBlockForm-padding6-KoJAc {
	padding-bottom: 36px !important;
}

.StaticBlockForm-padding7-Ekej1 {
	padding-bottom: 42px !important;
}

.StaticBlockForm-paddingTop1-TcB2m {
	padding-top: 6px !important;
}

.StaticBlockForm-paddingTop2-Lgq9g {
	padding-top: 12px !important;
}

.StaticBlockForm-paddingTop3-kf461 {
	padding-top: 18px !important;
}

.StaticBlockForm-paddingTop4-FgmYh {
	padding-top: 24px !important;
}

.StaticBlockForm-paddingTop5-fBMaB {
	padding-top: 30px !important;
}

.StaticBlockForm-paddingTop6-SL9Aj {
	padding-top: 36px !important;
}

.StaticBlockForm-paddingTop7-id5tR {
	padding-top: 42px !important;
}

.StaticBlockForm-noPadding-V58Ww {
	padding: 0px !important;
}

.StaticBlockForm-textBold-lmNIm {
	font-weight: 500 !important;
}

.StaticBlockForm-textBolder-FPNiL {
	font-weight: 700 !important;
}

.StaticBlockForm-textNormal-lsAZO {
	font-weight: normal !important;
}

.StaticBlockForm-spaceBottom20-MpvNA {
	margin-bottom: 20px;
}

.StaticBlockForm-spaceBottom10-RAV6q {
	margin-bottom: 10px;
}

.StaticBlockForm-marginNone-mxKi5 {
	margin: 0;
}

.StaticBlockForm-spaceBottom15-KuY65 {
	margin-bottom: 15px;
}

.StaticBlockForm-marginTopNone-FGCD_ {
	margin-top: 0;
}

.StaticBlockForm-spaceTop11-eapy1 {
	margin-top: 11px;
}

.StaticBlockForm-spaceTop21-udZUB {
	margin-top: 21px;
}

.StaticBlockForm-spaceTop20-L6xcH {
	margin-top: 20px;
}

.StaticBlockForm-spaceTop10-t4cUx {
	margin-top: 10px;
}

/*New Design Text Colors */

.StaticBlockForm-textDarkBlue-qxCYB {
	color: rgb(20, 39, 94) !important;
}

.StaticBlockForm-textLightBlue-EDTym {
	color: rgb(57, 87, 106) !important;
}

.StaticBlockForm-textLightSandleGreen-zrPcG {
	color: rgb(76, 86, 41) !important;
}

.StaticBlockForm-textLightBrown-vLrTr {
	color: rgb(115, 79, 33) !important;
}

.StaticBlockForm-textMediumMaroon-XLBzA {
	color: rgb(87, 37, 51) !important;
}

.StaticBlockForm-textBrown-lKxjq {
	color: rgb(160, 47, 24) !important;
}

.StaticBlockForm-textMaroon-D8hN_ {
	color: rgb(155, 49, 67) !important;
}

.StaticBlockForm-textDarkBrown-sziHv {
	color: rgb(83, 18, 16) !important;
}

.StaticBlockForm-textMediumBrown-gXdtp {
	color: rgb(142, 28, 10) !important;
}

.StaticBlockForm-textSkyBlue-zbFmB {
	color: rgb(37, 117, 141) !important;
}

.StaticBlockForm-textGray-el0Oj {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `StaticBlockForm-commonHeaderAdmin-ZAV_y`,
	"adminLayout": `StaticBlockForm-adminLayout-IeAZ_`,
	"box": `StaticBlockForm-box-OD2Ko`,
	"exportLink": `StaticBlockForm-exportLink-IickN`,
	"blockCenter": `StaticBlockForm-blockCenter-oze8E`,
	"panelHeader": `StaticBlockForm-panelHeader-O17J9`,
	"currencyselect": `StaticBlockForm-currencyselect-r2Xoa`,
	"mar0": `StaticBlockForm-mar0-q7D32`,
	"sideAdminPageWrapper": `StaticBlockForm-sideAdminPageWrapper-golZJ`,
	"table": `StaticBlockForm-table-jbFYH`,
	"tableRow": `StaticBlockForm-tableRow-bxC4M`,
	"tableCell": `StaticBlockForm-tableCell-plkRP`,
	"formGroup": `StaticBlockForm-formGroup-o0yik`,
	"select": `StaticBlockForm-select-ttYb9`,
	"noMargin": `StaticBlockForm-noMargin-ZsJL5`,
	"labelTextNew": `StaticBlockForm-labelTextNew-VIRQw`,
	"displayInline": `StaticBlockForm-displayInline-MK80N`,
	"btnUPdate": `StaticBlockForm-btnUPdate-csauw`,
	"btnModalDelete": `StaticBlockForm-btnModalDelete-hDjhx`,
	"radioBtn": `StaticBlockForm-radioBtn-qjAkw`,
	"backgroundImg": `StaticBlockForm-backgroundImg-NtMxO`,
	"btnWidth": `StaticBlockForm-btnWidth-OL75q`,
	"bannerImageBg": `StaticBlockForm-bannerImageBg-JQ1kK`,
	"bannerDelete": `StaticBlockForm-bannerDelete-lhvgN`,
	"modalRoot": `StaticBlockForm-modalRoot-jlMgd`,
	"modalBorderBottom": `StaticBlockForm-modalBorderBottom-A2vmu`,
	"logInModalBody": `StaticBlockForm-logInModalBody-G6wHW`,
	"exportSection": `StaticBlockForm-exportSection-lA8tJ`,
	"exportSectionGridSub": `StaticBlockForm-exportSectionGridSub-ZcBf1`,
	"exportText": `StaticBlockForm-exportText-Vpeae`,
	"exportLinkImg": `StaticBlockForm-exportLinkImg-hjILQ`,
	"vtrMiddle": `StaticBlockForm-vtrMiddle-yljbZ`,
	"exportImg": `StaticBlockForm-exportImg-VfTXz`,
	"profileViewlabel": `StaticBlockForm-profileViewlabel-gzThf`,
	"profileViewMainContent": `StaticBlockForm-profileViewMainContent-jfxOg`,
	"profileViewMain": `StaticBlockForm-profileViewMain-hwGPQ`,
	"profileViewInner": `StaticBlockForm-profileViewInner-hYQAG`,
	"profileImageSection": `StaticBlockForm-profileImageSection-cUk_z`,
	"lastviewInner": `StaticBlockForm-lastviewInner-stMlf`,
	"whyHostHoriLine": `StaticBlockForm-whyHostHoriLine-escbg`,
	"tableGrid": `StaticBlockForm-tableGrid-U0lSv`,
	"headingContent": `StaticBlockForm-headingContent-x9dkr`,
	"refundTextColor": `StaticBlockForm-refundTextColor-DttG9`,
	"dividerLine": `StaticBlockForm-dividerLine-Powkx`,
	"smallContent": `StaticBlockForm-smallContent-FkhOs`,
	"ChangeToUpperCase": `StaticBlockForm-ChangeToUpperCase-yYWws`,
	"noBorder": `StaticBlockForm-noBorder-oRma7`,
	"siteAdminHeading": `StaticBlockForm-siteAdminHeading-KmGRc`,
	"siteAdminSubHeading": `StaticBlockForm-siteAdminSubHeading-yyOd_`,
	"adminFormDivider": `StaticBlockForm-adminFormDivider-l5nWV`,
	"errorMessage": `StaticBlockForm-errorMessage-hsZfW`,
	"labelText": `StaticBlockForm-labelText-_zWzW`,
	"space1": `StaticBlockForm-space1-OTlM4`,
	"space2": `StaticBlockForm-space2-VFpvR`,
	"space3": `StaticBlockForm-space3-SPgPQ`,
	"space4": `StaticBlockForm-space4-PeyF_`,
	"space5": `StaticBlockForm-space5-QoSU7`,
	"space6": `StaticBlockForm-space6-KY2O9`,
	"space7": `StaticBlockForm-space7-p5ssf`,
	"spaceTop8": `StaticBlockForm-spaceTop8-Cm4MQ`,
	"spaceTop1": `StaticBlockForm-spaceTop1-eId2C`,
	"spaceTop2": `StaticBlockForm-spaceTop2-OmgY8`,
	"spaceTop3": `StaticBlockForm-spaceTop3-nkHH7`,
	"spaceTop4": `StaticBlockForm-spaceTop4-GvtCw`,
	"spaceTop5": `StaticBlockForm-spaceTop5-ZUdi3`,
	"spaceTop6": `StaticBlockForm-spaceTop6-re7EM`,
	"spaceTop7": `StaticBlockForm-spaceTop7-F_por`,
	"padding1": `StaticBlockForm-padding1-Ql0lK`,
	"padding2": `StaticBlockForm-padding2-K_hTQ`,
	"padding3": `StaticBlockForm-padding3-HUZKd`,
	"padding4": `StaticBlockForm-padding4-zOhdx`,
	"padding5": `StaticBlockForm-padding5-sHjtO`,
	"padding6": `StaticBlockForm-padding6-KoJAc`,
	"padding7": `StaticBlockForm-padding7-Ekej1`,
	"paddingTop1": `StaticBlockForm-paddingTop1-TcB2m`,
	"paddingTop2": `StaticBlockForm-paddingTop2-Lgq9g`,
	"paddingTop3": `StaticBlockForm-paddingTop3-kf461`,
	"paddingTop4": `StaticBlockForm-paddingTop4-FgmYh`,
	"paddingTop5": `StaticBlockForm-paddingTop5-fBMaB`,
	"paddingTop6": `StaticBlockForm-paddingTop6-SL9Aj`,
	"paddingTop7": `StaticBlockForm-paddingTop7-id5tR`,
	"noPadding": `StaticBlockForm-noPadding-V58Ww`,
	"textBold": `StaticBlockForm-textBold-lmNIm`,
	"textBolder": `StaticBlockForm-textBolder-FPNiL`,
	"textNormal": `StaticBlockForm-textNormal-lsAZO`,
	"spaceBottom20": `StaticBlockForm-spaceBottom20-MpvNA`,
	"spaceBottom10": `StaticBlockForm-spaceBottom10-RAV6q`,
	"marginNone": `StaticBlockForm-marginNone-mxKi5`,
	"spaceBottom15": `StaticBlockForm-spaceBottom15-KuY65`,
	"marginTopNone": `StaticBlockForm-marginTopNone-FGCD_`,
	"spaceTop11": `StaticBlockForm-spaceTop11-eapy1`,
	"spaceTop21": `StaticBlockForm-spaceTop21-udZUB`,
	"spaceTop20": `StaticBlockForm-spaceTop20-L6xcH`,
	"spaceTop10": `StaticBlockForm-spaceTop10-t4cUx`,
	"textDarkBlue": `StaticBlockForm-textDarkBlue-qxCYB`,
	"textLightBlue": `StaticBlockForm-textLightBlue-EDTym`,
	"textLightSandleGreen": `StaticBlockForm-textLightSandleGreen-zrPcG`,
	"textLightBrown": `StaticBlockForm-textLightBrown-vLrTr`,
	"textMediumMaroon": `StaticBlockForm-textMediumMaroon-XLBzA`,
	"textBrown": `StaticBlockForm-textBrown-lKxjq`,
	"textMaroon": `StaticBlockForm-textMaroon-D8hN_`,
	"textDarkBrown": `StaticBlockForm-textDarkBrown-sziHv`,
	"textMediumBrown": `StaticBlockForm-textMediumBrown-gXdtp`,
	"textSkyBlue": `StaticBlockForm-textSkyBlue-zbFmB`,
	"textGray": `StaticBlockForm-textGray-el0Oj`
};
module.exports = ___CSS_LOADER_EXPORT___;
